type DatePart = "year" | "month" | "day" | "full";

interface DateParts {
  year: string;
  month: string;
  day: string;
  full: string;
}

export const currentDate = (
  type: DatePart = "full",
  separator: string = "-",
): string => {
  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, "0");
  const day = String(today.getDate()).padStart(2, "0");

  const obj: DateParts = {
    year: year.toString(),
    month,
    day,
    full: [year, month, day].join(separator),
  };

  return obj[type];
};
